import "./UserAE.css";
import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import { UsersCreate, UsersFilter, UsersUpdate } from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

function UserAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      if (id) {
        const UsersFilterData = await UsersFilter({ id: id });
        if (UsersFilterData.status && UsersFilterData.status === 200) {
          setForm(UsersFilterData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    const regex = /^09\d{9}$/;

    // if (!id &&!regex.test(form.userName)) {
    //   toast.error("شماره موبایل معتبر نیست ");
    //   validation = false;
    // }

    if (form.companyName === "") {
      toast.error("نام شرکت را وارد نمایید ");
      validation = false;
    }
    if (form.firstName === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (form.lastName === "") {
      toast.error("نام خانواذگس را وازد نمایید ");
      validation = false;
    }
    if (!id &&form.userName === "") {
      toast.error(" شماره موبایل را وازد نماییئ");
      validation = false;
    }
    if (form.password === "") {
      toast.error("رمز عبور را وارد نمایید");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const UsersUpdateData = await UsersUpdate(form, id);
          if (UsersUpdateData.status && UsersUpdateData.status === 200) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/User");
          }
        } else {
          const UsersCreateData = await UsersCreate(form);
          if (UsersCreateData.status && UsersCreateData.status === 200) {
            toast.success("افزودن کاربر جدید با موفقیت انجام شد");
            navigate("/Panel/User");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <InputCus
                type="text"
                name="companyName"
                id="companyName"
                text="نام شرکت"
                value={form.companyName || ""}
                onChange={handleChangeSearch}
                className="m-2"
              />
              <InputCus
                type="text"
                name="firstName"
                id="firstName"
                text="نام"
                value={form.firstName || ""}
                onChange={handleChangeSearch}
                className="m-2"
              />
              <InputCus
                type="text"
                name="lastName"
                id="lastName"
                text="نام خانوادگی"
                value={form.lastName || ""}
                onChange={handleChangeSearch}
                className="m-2"
              />
              {!id && (
                <InputCus
                  type="text"
                  name="userName"
                  id="userName"
                  text="شماره موبایل"
                  value={form.userName || ""}
                  onChange={handleChangeSearch}
                  className="m-2"
                />
              )}
              {!id && (
                <InputCus
                  type="text"
                  name="nationalCode"
                  id="nationalCode"
                  text="کد ملی "
                  value={form.nationalCode || ""}
                  onChange={handleChangeSearch}
                  className="m-2"
                />
              )}
              <InputCus
                type="text"
                name="password"
                id="password"
                text="Password"
                value={form.password || ""}
                onChange={handleChangeSearch}
                className="m-2"
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button
                onClick={() => {
                  AddUpdate();
                }}
                className="butAU"
              >
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserAE;
